import React from "react";
import "./TitleBanner.scss";
import PropTypes from "prop-types";

var isFirstReturnStroke = false;
function TitleBanner({ placeholder, enableAutoFocus, handleOnEnterPress }) {
  const handleOnKeyDown = (e) => {
    if (e.key === "Enter" && handleOnEnterPress) {
      if (isFirstReturnStroke) {
        isFirstReturnStroke = false;
        handleOnEnterPress();
      } else {
        isFirstReturnStroke = true;
      }
    } else {
      isFirstReturnStroke = false;
    }
  };

  return (
    <input
      className="title-banner"
      type="text"
      autoFocus={enableAutoFocus}
      placeholder={placeholder}
      onKeyUp={handleOnKeyDown}
    />
  );
}

TitleBanner.propTypes = {
  placeholder: PropTypes.string,
  enableAutoFocus: PropTypes.bool,
  handleOnEnterPress: PropTypes.func,
};

export default TitleBanner;
